import React, { useMemo, useCallback } from "react";
import styled from "styled-components";
import Modal from "common/Modal";
import GoogleMapReact from "google-map-react";
import Marker from "./Marker";
import { useAsyncLoader } from "utils/useAsyncLoader";
import { getCompanyEvents } from "utils/api";
import { useNavigate } from "react-router-dom";
import { KeyboardArrowRight, CheckCircle, StarBorder, Star } from "@material-ui/icons";
import getIconFromId from "utils/getIconFromId";
import {
  doCompanySearch,
  setCompanyFavouriteGRSDB,
  deleteCompanyFavouritesGRSDB,
  deleteCompanyFavourites,
  setCompanyFavourite,
} from "utils/api";
import { NotificationManager } from "react-notifications";

import CircularProgress from "@material-ui/core/CircularProgress";

export const Loading = styled.div`
  color: ${({ theme }) => theme.primaryColor};
  display: flex;
  flex-direction: row;
  justify-content: center;
  z-index: 5;
  font-size: 32px;
  font-weight: bold;
`;

async function extendDoCompanySearch(eventName, bisnode_id) {
  if (bisnode_id) {
    return bisnode_id;
  }
  console.warn("call not needed anymore, please debug");
  const grsdbsearch = await doCompanySearch({
    data: {
      type: "company",
      sort: [{ id: "co_zip", order: "asc" }],
      offset: 0,
      limit: parseInt(process.env.REACT_APP_SEARCH_LIMIT),
      q: eventName,
      filter: [[{ id: "oob", option: "eq", value: false }]],
    },
  });
  if (grsdbsearch.results.length === 0) {
    return null;
  }
  return grsdbsearch.results[0].bisnode_id;
}

const HolderDiv = styled.div`
  width: 100%;
  height: 200px;
`;
const CompanyDiv = styled.div`
  padding: 10px 20px;
`;
const Branch = styled.div`
  background-color: ${({ theme }) => theme.primaryHover};
  border-radius: 2px;
  display: inline-block;
  margin: 2px;
  min-width: 0;
  box-sizing: border-box;
  color: white;
  font-size: 85%;
  overflow: hidden;
  padding: 3px;
  padding-left: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const UrlLink = styled.a`
  color: ${({ theme }) => theme.interactionColorDark};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  margin-bottom: 15px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
  cursor: pointer;
`;
const ListOfEventsBlock = styled.div`
  display: flex;
  flex-flow: column nowrap;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: flex-start;
  height: calc(100% - 85px);
`;
const RowTh = styled.div`
  display: flex;
  width: calc(100% - 90px);
  font-size: 14px;
  position: sticky;
  background-color: #fff;
  z-index: 9999;
  min-height: 20px;
  top: 0;
  align-self: flex-start;
  padding: 18px 45px 10px 15px;
  color: #546472;
  padding-bottom: 10px;
  border-bottom: 1px solid #f1f1f1;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  & > div:nth-child(1) {
    width: 40%;
  }
  & > div:nth-child(2) {
    width: 60%;
  }
  & > div:nth-child(3) {
    width: 30%;
    text-align: right;
  }
`;
const FlexHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
`;
const FlexHolderStart = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
`;
const ImgOverlay = styled.div`
  background-color: #ffffff;
  width: 20px;
  height: 30px;
  position: absolute;
  z-index: 99;
  left: -20px;
`;
const ImgHolder = styled.div`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0px;
  z-index: 9;
  left: -25px;
`;

const RowTd = styled.div`
  display: flex;
  width: 100%;
  width: calc(100% - 90px);
  padding: 15px 45px 15px 35px;
  min-height: 20px;
  flex-flow: row nowrap;
  cursor: pointer;
  justify-content: flex-start;
  align-items: flex-start;
  &:hover {
    background-color: #f1f1f1;
  }
  &:hover > ${FlexHolderStart} > ${ImgHolder} > ${ImgOverlay} {
    background-color: #f1f1f1;
  }
  & > div:nth-child(1) {
    width: 40%;
  }
  & > div:nth-child(2) {
    width: 60%;
  }
  & > div:nth-child(3) {
    text-align: right;
    width: 30%;
  }
`;
const EventsHolder = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column nowrap;
`;

const TitleHolder = styled.div`
  width: calc(100% - 10px);
  display: flex;
  align-items: center;
`;
const Title = styled.span`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const StyledKeyboardArrowRight = styled(KeyboardArrowRight)`
  position: absolute;
  right: -25px;
  top: 0px;
`;
const EventDescription = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  // white-space: nowrap;
`;
const Img = styled.img`
  background: transparent;
  margin-left: -20px;
  width: 100%;
`;

function getIconForEvent(channel, channels, forColor) {
  const ch = channels.find(ch => ch.id === channel);
  // const icon = getIconFromId(ch.icon);
  if (!ch) {
    return null;
  }
  if (forColor) {
    return `#${ch.color}`;
  }
  return ch.icon;
}

export function Events({ events, channels }) {
  const navigate = useNavigate();

  const sortedEvents = useMemo(
    () => events && [...events].sort((a, b) => new Date(b.date) - new Date(a.date)),
    [events]
  );
  return (
    <ListOfEventsBlock>
      <RowTh>
        <div>Ereignis</div>
        <div>Abstract</div>
        <div>Datum</div>
      </RowTh>
      <EventsHolder>
        {sortedEvents?.length > 0 ? (
          sortedEvents.map((e, index) => (
            <React.Fragment key={`${e.id}_${index}`}>
              <RowTd
                onClick={() => {
                  navigate({ pathname: `/map/event/${e.id}` });
                  e.read = true;
                }}
              >
                <FlexHolderStart>
                  <ImgHolder>
                    <ImgOverlay />
                    <Img
                      style={{
                        filter: `opacity(1) drop-shadow(20px 0px 0px ${getIconForEvent(
                          e.type,
                          channels,
                          {
                            forColor: true,
                          }
                        )})`,
                      }}
                      src={getIconFromId(getIconForEvent(e.type, channels))}
                      alt="company-img"
                    />
                  </ImgHolder>
                  <TitleHolder>
                    <Title>{e.title}</Title>
                    {e.read ? (
                      <span
                        title="gelesen"
                        style={{
                          marginLeft: "5px",
                          color: "#366b14",
                          height: "20px",
                        }}
                      >
                        <CheckCircle fontSize="small" />
                      </span>
                    ) : null}
                  </TitleHolder>
                </FlexHolderStart>
                <EventDescription>{e.abstract}</EventDescription>
                <FlexHolder>
                  {e.date}
                  <StyledKeyboardArrowRight fontSize="small" />
                </FlexHolder>
              </RowTd>
            </React.Fragment>
          ))
        ) : (
          <div>Keine Ereignisse</div>
        )}
      </EventsHolder>
    </ListOfEventsBlock>
  );
}

export default function CompanyDetailedInfo({
  markerColor,
  markerPosition,
  selectedCompany,
  title,
  isOpen,
  setIsOpen,
  channels,
}) {
  const { lat, lng } = markerPosition;

  const { data: bisnode_id } = useAsyncLoader(
    extendDoCompanySearch,
    title,
    selectedCompany?.bisnode_id
  );

  const { data: companyEventData, isLoading } = useAsyncLoader(getCompanyEvents, bisnode_id);

  const companyBranches = useMemo(() => {
    if (selectedCompany?.company_wz2008?.length > 0) {
      return selectedCompany?.company_wz2008;
    }

    if (companyEventData?.wz2008?.length > 0) {
      return companyEventData?.wz2008;
    }

    return [];
  }, [companyEventData, selectedCompany]);

  const handleCompanyFavorite = useCallback(
    async e => {
      e.preventDefault();
      const isDak = selectedCompany.isDak;
      const showStar =
        selectedCompany?.co_street && selectedCompany?.co_zip && selectedCompany?.co_city;

      if (!showStar) {
        return;
      }
      const isFavorit = selectedCompany.favorite;
      try {
        selectedCompany.favorite = !selectedCompany.favorite;
        if (isDak) {
          if (isFavorit) {
            await deleteCompanyFavourites(selectedCompany.id);
          } else {
            await setCompanyFavourite(selectedCompany.id);
          }
        } else {
          if (isFavorit) {
            await deleteCompanyFavouritesGRSDB(selectedCompany.bisnode_id);
          } else {
            await setCompanyFavouriteGRSDB(selectedCompany);
          }
        }
      } catch (e) {
        NotificationManager.error("Operation fehlgeschlagen");
        selectedCompany.favorite = isFavorit;
      }
    },
    [selectedCompany]
  );

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(null)}
      noBottomMargin
      modalTitle={title}
      FavIcon={
        selectedCompany.favorite ? (
          <Star style={{ marginLeft: "4px", cursor: "pointer" }} onClick={handleCompanyFavorite} />
        ) : selectedCompany?.co_street && selectedCompany?.co_zip && selectedCompany?.co_city ? (
          <StarBorder
            style={{ marginLeft: "4px", cursor: "pointer" }}
            onClick={handleCompanyFavorite}
          />
        ) : null
      }
    >
      {!isLoading && companyEventData ? (
        <>
          <HolderDiv>
            <GoogleMapReact
              options={{ fullscreenControl: false, zoomControl: false }}
              bootstrapURLKeys={{
                key: "AIzaSyDvXLFUSfLOZVCuK3_E3FwBn3lieP8Gt4U",
              }}
              defaultCenter={{
                lat: parseFloat(lat),
                lng: parseFloat(lng),
              }}
              defaultZoom={16}
              yesIWantToUseGoogleMapApiInternals
            >
              <Marker lat={lat} lng={lng} markerColor={markerColor} />
            </GoogleMapReact>
          </HolderDiv>
          <CompanyDiv>
            <div>
              <b>Adresse</b>
            </div>
            <div>{selectedCompany.formatted_address || selectedCompany.description}</div>
            <br />
            <div>
              <b>Telefonnummer</b>
            </div>
            <div>{selectedCompany?.phone || "-"}</div>
            <br />
            <div>
              <b>Branche</b>
            </div>
            <div>
              {companyBranches.length > 0
                ? companyBranches.map((branch, index) => (
                    <Branch key={index}>
                      {branch?.wz2008_text || branch[Object.keys(branch)[0]]}
                    </Branch>
                  ))
                : "-"}
            </div>
            <br />
            <div>
              <b>Internetseite</b>
            </div>
            {companyEventData ? (
              <>
                <div>
                  <UrlLink
                    href={
                      companyEventData && companyEventData.url
                        ? companyEventData.url.match("https?://")
                          ? companyEventData.url
                          : `https://${companyEventData.url}`
                        : null
                    }
                    target="_blank"
                    title={companyEventData?.url}
                  >
                    {companyEventData?.url || "-"}
                  </UrlLink>
                </div>
                <br />

                <div>
                  <b>E-Mail-Adresse</b>
                </div>
                <div>{companyEventData?.email || "-"}</div>
              </>
            ) : (
              <div>Informationen werden geladen</div>
            )}

            <br />
            <div>
              <b>Anzahl der Mitarbeitenden</b>
            </div>
            <div>{selectedCompany?.employees || "-"}</div>
            <br />
            <div>
              <b>Ereignis</b>
            </div>
            <div>
              <Events events={companyEventData?.events} channels={channels} />
            </div>
            <br />
          </CompanyDiv>
        </>
      ) : (
        <Loading>
          <CircularProgress disableShrink color="inherit" />
        </Loading>
      )}
    </Modal>
  );
}
